module.exports = __webpack_public_path__ + "media/public/img/logo-tomis-f8961ade42388a538ee96ed6bf44355f.png";